import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../web/components-v2/Theme/theme';
import tysonBackgroundImage from '../assets/tyson-background.png';
import { titles, warningDark } from '../styles/colors';

export const styleSheet = StyleSheet.create({
	noCoffee: {
		background: warningDark,
		color: titles,
		padding: SPACE[20],
		position: 'absolute',
		top: 105,
		width: '100vw',
		zIndex: 1000,
	},
	subBar: {
		alignItems: 'center',
		display: 'flex',
		width: '100%',
	},
	statusBannerInGrid: {
		// The grid places this row; drop the legacy viewport pinning so `top`/`left`/`right` stop applying.
		position: 'static',
		flex: 1,
	},
	progressBar: {
		marginRight: SPACE[12],
	},
	tysonBackground: {
		backgroundColor: `#22D363`,
		backgroundImage: `url("${tysonBackgroundImage}")`,
		backgroundPosition: 'center top',
		backgroundRepeat: 'repeat-x',
		backgroundSize: 'contain',
	},
});
